import {
	Box,
	Container,
	Header,
	ColumnLayout
} from '@cloudscape-design/components'
import { FC, ReactNode } from 'react'

interface ValueWithLabelProps {
	label: string
	value: string | { value?: string; label?: string }
	version: string[]
}

interface ProjectProps {
	project: Record<any, any>
	children?: ReactNode
}

/** Ensure we never render an object (e.g. { value, label }) as a React child */
const safeDisplayValue = (v: ValueWithLabelProps['value']): string => {
	if (v == null) return ''
	if (typeof v === 'object') return (v.label ?? v.value) ?? ''
	return String(v)
}

const ValueWithLabel: FC<ValueWithLabelProps> = ({ label, value, version }) => {
	return (
		<div>
			<Box variant="awsui-key-label">{label}</Box>
			<div>{safeDisplayValue(value)}</div>
			{version.map((item, index) => (
				<div key={index}>
					<s>{item}</s>
				</div>
			))}
		</div>
	)
}

const RenderProjectFields: FC<ProjectProps> = ({ project, children }) => {
	return (
		<>
			<Container>
				<Header variant="h3">Request Details</Header>
				<ColumnLayout columns={3} variant="text-grid">
					{project.map((element: ValueWithLabelProps, index: number) => {
						return <ValueWithLabel {...element} key={element.label + index} />
					})}
				</ColumnLayout>
				{children}
			</Container>
		</>
	)
}

export default RenderProjectFields
